import { render, staticRenderFns } from "./OpenHoursView.vue?vue&type=template&id=4178831d"
import script from "./OpenHoursView.vue?vue&type=script&lang=js"
export * from "./OpenHoursView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports